import type { Styles } from 'common/types';

export const styles: Styles = {
  listWrapper: {
    position: 'relative',
    width: '100%',
    margin: '0',
  },
  slider: {
    background: 'transparent',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'stretch',
    width: '100%',
    overflowX: 'auto',
    position: 'relative',
    padding: '0',
    paddingBottom: '4px',
    transition: 'background-color 0.2s ease',
    gap: '16px',
    '&::-webkit-scrollbar': {
      height: '8px',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f5f9',
      borderRadius: '10px',
      margin: '0 16px',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '10px',
      backgroundColor: '#cbd5e1',
      '&:hover': {
        backgroundColor: '#94a3b8',
      },
    },
  },
  sliderDraggingOver: {
    background: 'rgba(0,0,0,0.02)',
  },
  itemContainer: {
    minWidth: '280px',
    maxWidth: '280px',
    display: 'flex',
    flexDirection: 'column',
    userSelect: 'none',
    transition: 'transform 0.2s ease',
  },
  itemDragging: {
    transform: 'scale(1.02)',
    zIndex: 100,
    boxShadow: '0 12px 24px rgba(0,0,0,0.15)',
    borderRadius: '16px',
  },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    py: 6,
    px: 3,
    backgroundColor: '#f8fafc',
    border: '2px dashed',
    borderColor: 'divider',
    borderRadius: '12px',
    textAlign: 'center',
  },
};
